module.exports = __webpack_public_path__ + "img/figure1-main.47f47030.png";